import { render, staticRenderFns } from "./EstadoPagoVocales.vue?vue&type=template&id=1c6c5647&scoped=true"
import script from "./EstadoPagoVocales.vue?vue&type=script&lang=js"
export * from "./EstadoPagoVocales.vue?vue&type=script&lang=js"
import style0 from "./EstadoPagoVocales.vue?vue&type=style&index=0&id=1c6c5647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6c5647",
  null
  
)

export default component.exports